// What a screen looks like while its chunk is downloading.
//
// Every screen is now a separate chunk (App.js, React.lazy), so between the
// click and the screen there is a moment where the browser is fetching it. A
// spinner in the middle of a white page reads as "something is wrong"; a grey
// outline of the screen that is coming reads as "it is on its way", and the
// page does not jump when the real thing lands on top of it.
//
// Deliberately generic: one skeleton for a hundred and seventy screens, shaped
// like the thing they have in common - a title, a row of cards, a table.
import React from 'react';
import { Box, Skeleton } from '@mui/material';

export default function RouteSkeleton({ rows = 6 }) {
  return (
    <Box sx={{ p: { xs: 2, md: 3 } }} aria-busy='true' aria-label='Loading'>
      {/* Title */}
      <Skeleton variant='text' width={260} height={38} />

      {/* The row of figures most screens open with. */}
      <Box
        sx={{
          display: 'grid',
          gap: 1.5,
          my: 2,
          gridTemplateColumns: {
            xs: 'repeat(2, minmax(0,1fr))',
            md: 'repeat(4, minmax(0,1fr))',
          },
        }}>
        {[0, 1, 2, 3].map((i) => (
          <Skeleton key={i} variant='rounded' height={82} />
        ))}
      </Box>

      {/* Filters */}
      <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', mb: 2 }}>
        <Skeleton variant='rounded' width={220} height={38} />
        <Skeleton variant='rounded' width={150} height={38} />
        <Skeleton variant='rounded' width={150} height={38} />
        <Skeleton variant='rounded' width={110} height={38} />
      </Box>

      {/* The table. Each row a shade fainter than the one above, so the eye
          reads it as a list continuing rather than a block of grey. */}
      <Box sx={{ border: '1px solid #e2e8f0', borderRadius: 2, p: 1.5 }}>
        <Skeleton variant='text' height={30} />
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton
            key={i}
            variant='text'
            height={26}
            sx={{ opacity: Math.max(0.35, 1 - i * 0.12) }}
          />
        ))}
      </Box>
    </Box>
  );
}
